<template>
  <tr class="operative-table-body-row">
    <th class="operative-table-header-column">
      <strong v-if="strong"><slot></slot></strong>
      <em v-else-if="em"><slot></slot></em>
      <slot v-else></slot>
    </th>
    <th v-if="withTotal" :class="{ 'text-left': align === 'left', 'text-center': align === 'center', 'text-right': align === 'right' }">
      <strong v-if="strong"><slot name="total" :total="total">{{ total }}</slot></strong>
      <em v-else-if="em"><slot name="total" :total="total">{{ total }}</slot></em>
      <template v-else><slot name="total" :total="total">{{ total }}</slot></template>
    </th>
    <template v-for="(value, i) in values">
      <slot name="cell-container" :value="value" :i="i" :strong="strong">
        <td class="operative-table-value-column" :key="'row-cell-' + i" :class="{ 'text-left': align === 'left', 'text-center': align === 'center', 'text-right': align === 'right' }">
          <strong v-if="strong">
            <slot name="cell-content" :value="value" :col="i">
              {{ value }}
            </slot>
          </strong>
          <em v-else-if="em">
            <slot name="cell-content" :value="value" :col="i">
              {{ value }}
            </slot>
          </em>
          <template v-else>
            <slot name="cell-content" :value="value" :col="i">
              {{ value }}
            </slot>
          </template>
        </td>
      </slot>
    </template>
  </tr>
</template>

<script>

export default {
  name: 'operative-table-body-row',
  props: {
    values: {
      type: Array,
      default: () => [],
    },
    strong: {
      type: Boolean,
      default: false,
    },
    em: {
      type: Boolean,
      default: false,
    },
    withTotal: {
      type: Boolean,
      default: false,
    },
    totalReducer: {
      type: Function,
      default: (value, total) => total + value,
    },
    align: {
      type: String,
      default: 'default',
    },
  },
  computed: {
    total () {
      return (this.values || []).reduce(this.totalReducer);
    },
  },
};

</script>

<style lang="scss">

.operative-table-body-row {
  th {
    font-weight: normal;
  }

  .operative-table-value-column {
    text-align: right;
  }
}

</style>
